import { motion, useAnimation } from "framer-motion";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function TopProgressBar() {
  const { pathname } = useLocation();
  const controls = useAnimation();

  useEffect(() => {
    // Skip progress bar for modals
    if (location.state?.background) return;

    const handleRouteChange = async () => {
      // Reset position
      await controls.set({ width: "0%", opacity: 1 });
      
      // Speed through the first 70%
      await controls.start({
        width: "70%",
        transition: { duration: 0.4, ease: "easeOut" }
      });

      // Complete the bar
      await controls.start({
        width: "100%",
        transition: { duration: 0.2, ease: "easeIn" }
      });

      // Fade out
      await controls.start({
        opacity: 0,
        transition: { delay: 0.1, duration: 0.2 }
      });
    };

    handleRouteChange();
  }, [pathname, controls]);

  return (
    <motion.div
      animate={controls}
      className="fixed top-0 left-0 right-0 z-[9999] h-[3px] bg-gradient-to-r from-rose-500 via-pink-500 to-rose-600 origin-left"
      style={{ opacity: 0 }}
    />
  );
}
